import { useSelectedCollectionMetadata } from '@features/metadata/hooks';
import { useTranslation } from 'react-i18next';
import { MetadataEditorProvider } from '../context/MetadataEditorContext';
import { MetadataEditorForm } from './MetadataEditorForm';
import { SlidingPanel } from '@common/components/SlidingPanel/SlidingPanel';

interface MetadataEditorPanelProps {
    open: boolean;
    onClose: () => void;
}

export const MetadataEditorPanel = ({
    open,
    onClose,
}: MetadataEditorPanelProps) => {
    const { data, sources } = useSelectedCollectionMetadata();
    const { t } = useTranslation('metadataEditor');

    const isDataReady = !!data && !!sources;

    return (
        <SlidingPanel
            open={open && isDataReady}
            onClose={onClose}
            title={t('title')}
            subtitle={data.title}
            width={{ initial: '100%', sm: '600px' }}
        >
            {isDataReady && (
                <MetadataEditorProvider sources={sources} mergedData={data}>
                    <MetadataEditorForm onClose={onClose} />
                </MetadataEditorProvider>
            )}
        </SlidingPanel>
    );
};
